import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/svgs/expenses-white.svg'
import _imports_1 from '@/assets/icons/edit.svg'


const _hoisted_1 = { class: "flex flex-col lg:flex-row items-center justify-between bg-white rounded-2xl shadow p-8 mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col lg:flex-row items-center lg:w-2/6 w-full justify-center lg:justify-start lg:items-start"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center rounded-full bg-primary-dark w-12 h-12" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "font-semibold lg:ml-4"
}
const _hoisted_5 = { class: "flex flex-col w-full lg:w-1/6 items-center justify-center text-center lg:text-left mt-3 lg:mt-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary lg:text-gray-500 font-semibold lg:font-normal" }, "Title", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary lg:text-gray-500 font-semibold lg:font-normal" }, "Description", -1)
const _hoisted_8 = {
  class: "truncate text-center",
  style: {"width":"160px"}
}
const _hoisted_9 = {
  key: 0,
  class: "absolute bg-white border-2 border-primary rounded p-4 inset-x-0 top-0 mt-12"
}
const _hoisted_10 = { class: "flex flex-col w-full lg:w-1/6 items-center justify-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary lg:text-gray-500 font-semibold lg:font-normal" }, "Requested on", -1)
const _hoisted_12 = { class: "flex flex-col w-full lg:w-1/6 items-center justify-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary lg:text-gray-500 font-semibold lg:font-normal" }, " Amount ", -1)
const _hoisted_14 = { class: "uppercase" }
const _hoisted_15 = { class: "flex flex-col w-1/24 items-center justify-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_ModalExpenses = _resolveComponent("ModalExpenses")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.extraCharge.payroll_period)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.extraCharge.payroll_period.company.visible_name), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(_ctx.extraCharge.title), 1)
      ]),
      _createElementVNode("div", {
        class: "relative flex flex-col w-full lg:w-1/6 items-center justify-center",
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTooltip = true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTooltip = false))
      }, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.extraCharge.description), 1),
        (_ctx.showTooltip && _ctx.hasTooltip)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(_ctx.extraCharge.description), 1)
            ]))
          : _createCommentVNode("", true)
      ], 32),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", null, [
          _createVNode(_component_DateFormatter, {
            date: _ctx.extraCharge.created_at
          }, null, 8, ["date"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("span", null, [
          _createTextVNode("$" + _toDisplayString((_ctx.extraCharge.original_amount / 100).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })) + " ", 1),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.extraCharge.currency), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        (
          _ctx.extraCharge.payroll_period.stripe_invoice_status === 'not_created'
        )
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal = true)),
              class: "hover:bg-background p-4 rounded"
            }, _hoisted_17))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalExpenses, {
      extraCharge: _ctx.extraCharge,
      openModal: _ctx.openModal,
      "onUpdate:openModal": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.openModal) = $event))
    }, null, 8, ["extraCharge", "openModal"])
  ], 64))
}